import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { NavParams } from 'ionic-angular';

@Component({
  selector: 'page-best',
  templateUrl: 'best.html'
})
export class BestPage {

  features:Array<{}>
  renders:Array<{}>
  best:string
  bestTitle:string

  constructor(public navCtrl: NavController, private navParams: NavParams) {
    this.renders = navParams.get('bests');
    this.best = navParams.get('best');
    var feats = [
      {title:'Display',field:'feature1'},
      {title:'Câmera / Frontal',field:'feature2'},
      {title:'Processador',field:'feature3'},
      {title:'Memória RAM',field:'feature4'},
      {title:'Memória Interna',field:'feature5'},
      {title:'Bateria',field:'feature6'},
      {title:'Sistema (Versão)',field:'feature7'}
    ]
    this.features = [];
    console.log(this.best);
    for(var x1 in feats){
      if(feats[x1].field!=this.best){
        this.features.push(feats[x1]);
      }else{
        this.bestTitle = feats[x1].title;
      }
    }
    console.log(this.bestTitle);

  }

  backFilter() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/best/best.ts